import React from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center">
          <button
            onClick={handleBackClick}
            className="mr-2 hover:bg-gray-300 rounded-full p-1"
          >
            <FaArrowLeft className="w-5 h-5" />
          </button>
          <span className="text-xl md:text-2xl font-bold">Settings</span>
        </div>
      </div>
    </div>
  );
};

export default Settings;
